import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function useNavigateToContentPanel() {
	const navigate = useNavigate();
	const location = useLocation();
	return useCallback((path: string, state?: Record<string, any>) => {
		// Don't navigate if we are already in the same path
		if (path === location.pathname) {
			return;
		}
		// Only replace if we are already in a content panel
		if (['/content/tabs', '/content/custom-tabs'].some(p => location.pathname.includes(p))) {
			navigate(path, { state: state ?? (location.state as Record<string, any>), replace: true });
		} else {
			navigate(path, { state: state ?? (location.state as Record<string, any>) });
		}
	}, [navigate, location]);

}
